import { NgClass } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { GenericCardComponent } from '../../../../../shared/components/generic-card/generic-card.component';
import { Event } from '../../../../../shared/model/event';
import { DateRangePipe } from '../../../../../shared/pipes/date-range.pipe';
import { TruncatePipe } from '../../../../../shared/pipes/truncate.pipe';
import { GeoLocationService } from '../../../services/geo-location.service';
import { UserGeolocationService } from '../../../../../shared/services/user-geolocation.service';
import { parseCoordinates } from '../../../../../shared/utils/geo-coordinates';
import { distanceFromUserLabel } from '../../../../../shared/utils/geo-distance';

@Component({
  selector: 'app-event-card',
  standalone: true,
  imports: [GenericCardComponent, DateRangePipe, TruncatePipe],
  templateUrl: './event-card.component.html',
  styleUrl: './event-card.component.css',
})
export class EventCardComponent {
  private geoLocationService: GeoLocationService = inject(GeoLocationService);
  private userGeolocation: UserGeolocationService = inject(UserGeolocationService);

  @Input({ required: true }) event!: Event;

  protected canEdit(): boolean {
    return this.event.isCreator;
  }

  protected detailLink(): Array<string | number> | null {
    return this.event.id != null ? ['/events/detail', this.event.id] : null;
  }

  protected editLink(): Array<string | number> | null {
    return this.event.id != null ? ['/events/edit', this.event.id] : null;
  }

  protected locationCityAndProvince(): string {
    return this.geoLocationService.locationCityAndProvince(this.event.location);
  }

  protected distanceLabel(): string {
    return distanceFromUserLabel(
      this.userGeolocation.position(),
      parseCoordinates(this.event.location),
    );
  }
}
